export default function useNavigationItems() {
  const { hotelsByContinentAndCity } = useHotels();
  const { locale, t } = useI18n();
  const localePath = useLocalePath();

  const { data: contentfulNavigation } = useFetch("/api/v2/navigation", {
    query: {
      locale,
    },
  });

  const hotelNavigationItems = computed(() => {
    return Object.keys(hotelsByContinentAndCity.value).map((continent) => {
      return {
        slug: localePath({
          name: "hotels-continent",
          params: {
            continent: hotelsByContinentAndCity.value[continent].slug,
          },
        }),
        title: hotelsByContinentAndCity.value[continent].title,
        navigationItems: Object.keys(
          hotelsByContinentAndCity.value[continent].cities,
        ).map((city) => ({
          slug: localePath({
            name: "hotels-continent-city",
            params: {
              continent: hotelsByContinentAndCity.value[continent].slug,
              city: hotelsByContinentAndCity.value[continent].cities[city].slug,
            },
          }),
          title: hotelsByContinentAndCity.value[continent].cities[city].title,
          navigationItems: hotelsByContinentAndCity.value[continent].cities[
            city
          ].hotels.map((hotel) => {
            // For failsafe, ensure we try to split a string. Fallbacks for continent,
            // city, and hotelSlug will be undefined, which means the link cannot be generated.
            // However, this makes sure at least we prevent an error from being thrown without proper ErrorBoundary.
            const [continent, city, hotelSlug] = String(hotel.slug).split("/");

            return {
              slug: localePath({
                name: "hotels-continent-city-hotelSlug",
                params: {
                  continent,
                  city,
                  hotelSlug,
                },
              }),
              title: hotel.name,
            };
          }),
        })),
      };
    });
  });

  const navBarItems = computed(() => {
    return {
      languages: contentfulNavigation.value?.languages,
      navigationItems: [
        {
          title: t("website.navigation.hotels.title"),
          navigationItems: hotelNavigationItems.value,
        },
        ...(contentfulNavigation.value?.navigationItems ?? []),
      ],
    };
  });

  return {
    navBarItems,
    hotelItems: hotelNavigationItems.value,
  };
}
